<div class="content-wrapper">
  <div class="breadcrumb" *ngFor="let crumb of breadcrumbList; let last = last">
    <a class="breadcrumb__link" *ngIf="last">{{ crumb.title }}</a>
    <a class="breadcrumb__link" *ngIf="!last" [routerLink]="crumb.path">{{ crumb.title }}</a>
    <mat-icon class="breadcrumb__icon" *ngIf="!last">arrow_right_alt</mat-icon>
  </div>
</div>
